import { render, staticRenderFns } from "./MarketInfoEdit.vue?vue&type=template&id=0ddaaa03&scoped=true"
import script from "./MarketInfoEdit.vue?vue&type=script&lang=js"
export * from "./MarketInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./MarketInfoEdit.vue?vue&type=style&index=0&id=0ddaaa03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddaaa03",
  null
  
)

export default component.exports